// extracted by mini-css-extract-plugin
export default {"emoji__cursor":"styles_emoji__cursor__aB8v+"};